module.exports = __webpack_public_path__ + "media/components/spaces/iconAnswersTapeNav-1758cfd112ab5600ca9b982fac4a1690.svg";